<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.link"
            id="odMonthlyTransItemLinkText"
            class="od-monthly-trans-item-link-text"
            label="Link"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.saiSection"
            id="odMonthlyTransItemSAISectionText"
            class="od-monthly-trans-item-sai-section-text"
            label="SAI Section"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.balanceLastMonth"
            id="odMonthlyTransItemBalanceLastMonthtText"
            class="od-monthly-trans-item-balance-last-month-text"
            label="Balance Last Month"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.deposits"
            id="odMonthlyTransItemDepositsText"
            class="od-monthly-trans-item-deposits-text"
            label="Deposits Last Month"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.transferIn"
            id="odMonthlyTransItemTransferInText"
            class="od-monthly-trans-item-transfer-in-text"
            label="Transfer In "
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.transferOut"
            id="odMonthlyTransItemransferOutText"
            class="od-monthly-trans-transfer-out-text"
            label="Transfer Out"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.vouchersRegistered"
            id="odMonthlyTransItemVouchersRegisteredText"
            class="od-monthly-trans-vouchersRegistered-text"
            label="Vouchers Registered"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="3">
          <v-text-field
            v-model="editedItem.balance"
            id="odMonthlyItemBalanceText"
            class="od-monthly-trans-item-balance-text"
            label="Balance"
            @blur="somethingChanged(); roundAmountFields()"
            @keydown.enter="somethingChanged"
            readonly
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import { amountFormat, amountToNumber } from '../../../../util/shared/vue-global';

const amountFields = ['balanceLastMonth', 'deposits', 'transferIn', 'transferOut', 'vouchersRegistered', 'balance', 'saiSection'];

export default {
  name: 'BanksMonthlyTransaction',
  components: {
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'banksMonthlyTrans-dialog',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'index',
      'isVisible',
    ]),
    editedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
    somethingChanged() {
      this.$emit('input', this.editedItem);
    },
    roundAmountFields() {
      return amountFields.forEach((f) => {
        this.editedItem[f] = amountFormat(amountToNumber(this.editedItem[f]));
      });
    },
  },
};
</script>
